module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAArCAYAAABBwhkuAAAAAXNSR0IArs4c6QAAAQpJREFUOE/tlbFKA0EQhr+9rHIKWmijRMLFNxELG1sbOzEB7U0pIj6EjVja2NpYiO8hcisheNfkCAaSoJsbWTxTJW46i2S6HT6W3X/mn1FJJg3gBNhkfCQI1yrJJAYiQE0ABTAO7APhBOg3PXBgD1jygP1/Bqf+zCuwrUvj5bFDfuRJO1Ij57g7oGwtG8BCocCX1qSry7RkyK0SkfClxfrNI1HW5S5QVByYC821FQ5re7wtWtqjauxfSEUHPLtnFDfGNmfn4VI13XkEHlxJlYAnoFqAhpzd+3Nl5iBzeWanKbyeMUbCTz2FC9O21FWJo48eW3/6+j2TWEHknRSzPUj9e6YjZ+Sc+jbXN/EMMQOMgN3BAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/editor-icon/zxs.png
// module id = KwL6
// module chunks = 3